import React from 'react';
import './Heading.css';

import { HiOutlineLightBulb } from 'react-icons/hi';


const Heading = ({ title, subTitle = '', sideHeading = false, linear = false }) => {

  return (
    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>

      {/* Render the subTitle section only if subTitle is provided */}
      {subTitle && (
        <div className="sub">

          {/* Render the left icon only when sideHeading is false */}
          {!sideHeading && <HiOutlineLightBulb className="icon" />}

          {/* Display the subtitle text */}
          <span>{subTitle}</span>

          {/* Always show the right icon */}
          <HiOutlineLightBulb className="icon" />

        </div>
      )}

      <h2>{title}</h2> {/* Display the title */}

    </div>
  );
};

export default Heading;